module.exports = __webpack_public_path__ + "media/images/front/icon_movie_ar-eba4f11ffbf7b0db4b81f2519bd5c85d.png";